export default "__VITE_ASSET__Csl5blHd__"